export const enumToDisplayString = (str: string | null | undefined): string => {
  if (!str) {
    return '';
  }
  return str.toLowerCase().replace(/_/g, ' ');
};
